<template>
  <component :is="tag">
    <slot/>
  </component>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import smoothReflow from 'vue-smooth-reflow'

@Component({
    name: 'SmoothReflow',
    mixins: [smoothReflow],
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        options: Object,
    },
})
export default class SmoothReflow extends Vue {
    mounted() {
        this.$smoothReflow(this.options)
    }
}
</script>